import React from 'react';
import PropTypes from 'prop-types';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import ImageRightBlock from '../ImageRightBlock';

export default function MarvelEnterprise({ buttonText, copy, image, title }) {
  return (
    <PageWrap size="l">
      <Spacing size="m" sizeM="xl" type="padding" position="topBottom">
        <ImageRightBlock
          title={title}
          artwork={image}
          buttonText={buttonText}
          copy={copy}
          link="/enterprise"
        />
      </Spacing>
    </PageWrap>
  );
}

MarvelEnterprise.propTypes = {
  image: PropTypes.object,
  buttonText: PropTypes.string,
  copy: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/MarvelEnterprise/index.js